// extracted by mini-css-extract-plugin
module.exports = {"authContainer":"styles_authContainer__b5Z3k"};